<template>
  <div
    class="ll-law-list"
    :class="{empty:lawList.length === 0}"
  >
    <div
      v-show="lawList.length > 0"
      class="law-title"
      :class="{noBorder:isloading}"
    >
      <p class="title select">
        {{ $t(collectTitle) }}
      </p>
      <p class="title date">
        {{ $t(dateTitle) }}
      </p>
      <p class="title">
        {{ $t(title) }}
      </p>
    </div>
    <LoadingProgressBar
      :isloading="isloading"
      @completed="$_hideProgress()"
    />
    <div class="law-list-wrap">
      <slot name="law-list" />
    </div>
    <div
      v-if="lawList.length > 0&&!isloading"
      class="paginate-wrap"
    >
      <LlPaginateList
        :isloading="isloading"
        :page-count="pageCount"
        :page-range="pageRange"
        :margin-pages="marginPages"
        :first-button-text="firstButtonText"
        :last-button-text="lastButtonText"
        :prev-text="prevText"
        :next-text="nextText"
        :container-class="containerClass"
        :first-last-button="firstLastButton"
        :from-data-num="paginate.fromDataNum"
        :to-data-num="paginate.toDataNum"
        :total-data-num="paginate.totalDataNum"
        :page="paginate.ingPage"
        @input="$_paginatePage($event)"
      />
    </div>
    <LlEmptyPic
      v-if="lawList.length === 0 && !isloading"
      :image="require('@/assets/image/img-empty/Blue-file-empty.png')"
      :title="emptyTitle"
      :content="emptyContent"
    />
  </div>
</template>
<script>
export default {
  name: "LlLawList",
  props: {
    emptyTitle: {
      type: String,
      default: "",
    },
    emptyContent: {
      type: String,
      default: "",
    },
    isloading: {
      type: Boolean,
      default: false,
    },
    lawList: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default: '名稱',
    },
    collectTitle: {
      type: String,
      default: '收藏',
    },
    dateTitle: {
      type: String,
      default: '生效日',
    },
    pageCount: {
      type: Number,
      default: 0,
    },
    pageRange: {
      type: Number,
      default: 0,
    },
    marginPages: {
      type: Number,
      default: 3,
    },
    firstButtonText: {
      type: String,
      default: "",
    },
    lastButtonText: {
      type: String,
      default: "",
    },
    prevText: {
      type: String,
      default: "",
    },
    nextText: {
      type: String,
      default: "",
    },
    containerClass: {
      type: String,
      default: "",
    },
    firstLastButton: {
      type: Boolean,
      default: false,
    },
    paginate: {
      type: Object,
    },
  },
  data: () => ({
    progressBarRate: 0,
    showProgress: true,
  }),
  watch: {
    isloading() {
      if (this.isloading) {
        this.$_showProgress();
      }
    },
  },
  methods: {
    $_showProgress() {
      this.showProgress = true;
    },
    $_hideProgress() {
      this.showProgress = false;
    },
    $_paginatePage($event) {
      this.$emit("input", $event);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-law-list";
</style>